import Alpine from 'alpinejs'
import { convertObjectNumbersToString } from '../helpers/convertObjectNumbersToString'
import { pushDataLayer } from '../helpers/pushDataLayer'
import { Endpoints } from '../site'
import countries from '../countryCodes.json'

// Initial data, used to reset the form.
const initialFormData = () => ({
  topic: 'Udlejning',
  receiver: 'salg@jeudan.dk',
  first_name: '',
  last_name: '',
  phone: '',
  phone_country_code: '+45',
  email: '',
  company: '',
  body: '',
  accept_term: false,
  recaptcha_token: '',
  // Parkering
  parking_space: '',
  parking_from: '',
  // investor
  vp_number: '',
  address: '',
  zipcode: '',
  city: '',
  current_url: '',
})

Alpine.data('bookingFormOffice', (url) => ({
  formData: initialFormData(),
  submitted: false,
  errors: null,
  errorMessage: null,
  currentUrl: url,
  countries: countries,

  submit() {
    const thisData = this

    const membershipType = Alpine.store('officeMembership').type

    if (thisData.formData.current_url === '') {
      thisData.formData.current_url = thisData.currentUrl
    }
    // google reCaptcha script to get token
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(`${import.meta.env.MIX_RECAPTCHA_SITE_KEY as string}`, { action: 'contact_form' })
        .then(function (token) {
          // token to reCaptcha_token in formData.
          thisData.formData.recaptcha_token = token

          fetch(`${import.meta.env.MIX_API_BASE as string}${Endpoints.contactForm}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(convertObjectNumbersToString(thisData.formData)),
          }).then((response) => {
            if (response.ok) {
              pushDataLayer({
                event: 'book_viewing_form',
                mail: thisData.formData.email,
                phone: `${thisData.formData.phone_country_code} ${thisData.formData.phone}`,
                formSubject: thisData.formData.topic,
                serviceType: 'Udlejning',
                membershipType: membershipType,
              })
              thisData.submitted = true
              thisData.errors = null
              thisData.errorMessage = null
              thisData.formData = initialFormData()
              window.dispatchEvent(
                new CustomEvent('notice', {
                  detail: {
                    type: 'success',
                    text: 'Tak for din henvendelse. Vi sidder klar ved tasterne på hverdage mellem 8 og 17 – og vender retur hurtigst muligt. Har du akut brug for hjælp, kan du ringe døgnet rundt på 7010 6070.',
                  },
                })
              )
            } else {
              thisData.submitted = false
              response.json().then((data) => {
                thisData.errors = data.errors
                thisData.errorMessage = data.message
                window.dispatchEvent(
                  new CustomEvent('notice', { detail: { type: 'error', text: data.message } })
                )
              })
            }
          })
        })
    })
  },

  init() {},
}))
